<template>
	<div class="pa-3">
		<v-breadcrumbs :items="breadcrumbs" divider="&gt;"></v-breadcrumbs>

		<v-card flat class="pb-5">
			<v-card-text v-if="fixedUrlImages">
				<table id="fixed-url-image-table" width="100%" cellspacing="0">
					<tbody>
						<tr v-for="image in fixedUrlImages.items" :key="image.uuid">
							<td class="image-and-input">
								<v-text-field hide-details readonly :value="`https://www.jeban.com/vimg/${image.uuid}`" solo></v-text-field>
								<v-img :src="image.imageUrl"></v-img>
							</td>
							<td class="is-icon" width="125">
								<image-upload :use-slot="true" @upload-success="replaceImage">
									<v-btn color="grey" icon outline @click="markChange(image)">
										<v-icon>add_photo_alternate</v-icon>
									</v-btn>
								</image-upload>
							</td>
						</tr>
					</tbody>
					<tfoot>
						<tr>
							<td colspan="2">
								<image-upload :use-slot="true" @upload-success="addImage">
									<v-btn
										color="secondary">
										<v-icon left dark>add_photo_alternate</v-icon>
										Add Image
									</v-btn>
								</image-upload>
							</td>
						</tr>
					</tfoot>
				</table>
			</v-card-text>
		</v-card>

		<image-upload :use-slot="true" @upload-success="addImage">
			<v-btn fixed dark fab bottom right color="primary">
				<v-icon>add</v-icon>
			</v-btn>
		</image-upload>
		<!--
		<v-btn fixed dark fab bottom right color="primary">
			<v-icon>add</v-icon>
        </v-btn>
    	-->
	</div>
</template>

<script>
	import * as config from '@/config'
	import * as types from '@/stores/mutation-types'

	import FixedImageUrlCard from '@/views/cloud/fixed-image-url/Card.vue'
	import ImageUpload from '@/components/ImageUpload.vue'

	export default {
		components: {
			FixedImageUrlCard,
			ImageUpload
		},
		data () {
			return {
				breadcrumbs: [
					{
						text: 'Home',
						disabled: false,
						href: `${config.PUBLIC_PATH}`
					},
					{
						text: 'Cloud',
						disabled: true,
						href: `${config.PUBLIC_PATH}cloud`
					},
					{
						text: 'Fixed Image URL',
						disabled: true,
						href: `${config.PUBLIC_PATH}cloud/fixed-imagge-url`
					}					
				],
				fixedUrlImages: {},
				image2bChanged: {},
			}
		},
		methods: {
			scrollToTop () {
				window.scrollTo({ top: 0, behavior: 'smooth' })
			},
			handlePageChanged (page)
			{
				let url = `${config.BASE_URL}/fixedUrlImage/paginate`
				let params = { page: page, limit: this.pageSize }

				this.scrollToTop()

				axios.get( url, { params: params })
					.then((response) => {
						if (response.data.code == 0) {
							if (response.data.data.totalRecords > 0) {
								this.fixedUrlImages = {
									page: response.data.data.page,
									maxPage: this.fixedUrlImages.maxPage,
									totalRecords: response.data.data.totalRecords,
									items: response.data.data.fixedUrlImageList
								}
								if (response.data.data.totalRecords == this.pageSize) {
									this.fixedUrlImages.maxPage = (this.fixedUrlImages.page >= this.fixedUrlImages.maxPage) ? (this.fixedUrlImages.page + 1) : this.fixedUrlImages.maxPage
								} else if (response.data.data.totalRecords > 0) {
									this.fixedUrlImages.maxPage = this.fixedUrlImages.page
								} else {
									this.fixedUrlImages.maxPage = 1
									this.handlePageChanged(page - 1)
								}
							} else {
								this.fixedUrlImages = {
									page: 1,
									maxPage: 1,
									totalRecords: 0,
									items: []
								}
							}
						}
					})
			},
		    replaceImage(uploadResponse) {
                var index = this.fixedUrlImages.items.indexOf(this.image2bChanged)

                axios.put(`${config.BASE_URL}/fixedUrlImage/${this.fixedUrlImages.items[index].uuid}`, {'imageUrl': uploadResponse.imagePath})
                	.then(response => {
                		this.handlePageChanged(this.fixedUrlImages.page)
                	})
		    },
		    addImage (uploadResponse) {
                axios.post(`${config.BASE_URL}/fixedUrlImage`, {'imageUrl': uploadResponse.imagePath})
                	.then(response => {
                		this.handlePageChanged(this.fixedUrlImages.page)
                	})
		    },
		    markChange(item) {
		    	this.image2bChanged = item
		    },
		},
		mounted () {
			this.handlePageChanged(1)
		}

	}
</script>

<style lang="scss">
	table#fixed-url-image-table {
		border-collapse: collapse; 
		tr {
			border-top: 1px solid #eaeaea;
		}
		td {
			padding: 1rem 0;

			&.is-icon {
				border-left: 1px dashed #eaeaea;
			}
			&:not(.is-icon) {
				display: grid;
				// grid-auto-rows: min-content;
				// grid-gap: 15px;				
			}

 			img {
				width: 100%;
				height: auto;
			}
		}
		tbody {
			tr {
				&:nth-child(even) {
					background: #eaeaea;
				}
			}
			td:first-child {
				padding-right: 16px;
			}
		}
	}
	#content-table tr, 
	#content-table td {
		background: none!important;
	}
	#content-table td.is-icon {
		text-align: right;
	}
	td.image-and-input {
		display: grid;
		grid-template-columns: 1fr 240px;
		grid-gap: 15px;
		align-items: center;
		direction: rtl;

		@media (max-width: 767px) {
			grid-template-columns: 1fr;
			direction: ltr;
		}

		input {
			direction: ltr !important;
		}
	}
</style>